import * as PrismicTypes from '@prismicio/types'
import React from 'react'

import { Language } from '../../types/Types'
import { getAllDocumentsByType, getAllPages, getDocumentByUid, getLayoutData } from '../../utils/prismic/data-helpers'
import { getBreadCrumbs } from '../../utils/prismic/route-helpers'
import { ICrumb } from '../../components/BreadCrumbs'
import NextHeader from '../../components/NextHeader'
import PageTitle from '../../components/PageTitle'
import { getNewsArticleSEOData } from '../../utils/seo-helpers'
import RichTextAndImageCard from '../../components/RichTextAndImageCard'
import { NewsarticleDocument } from '../../../prismicio-types'

interface INewsArticlePage {
	page: NewsarticleDocument
	locale: Language
	crumbs: ICrumb[]
}

const Index: React.FC<INewsArticlePage> = ({ page, crumbs }) => {
	return (
		<>
			<NextHeader {...getNewsArticleSEOData(page)} />
			<PageTitle
				heading={page.data.title ?? ''}
				isSubtitleDate
				subtitle={page.data.published_date ?? ''}
				show_breadcrumbs={true}
				background_color={page.data.title_background_color ?? undefined}
				center_alignment={true}
				crumbs={[{ name: 'Fréttir /', url: '/frettir' }]}
			/>
			<RichTextAndImageCard
				content={page.data.content}
				background_color={page.data.background_color}
				display_image={true}
				image={page.data.preview_image}
			/>
		</>
	)
}

export async function getStaticProps({
	params,
	previewData,
	locale,
}: {
	locale: Language
	previewData: PrismicTypes.Ref
	params: { uid: string }
}) {
	const { ref } = previewData || {}

	const [page, layoutData, allPages] = await Promise.all([
		getDocumentByUid('newsarticle', params.uid as string, ref, locale),
		getLayoutData(ref, locale),
		getAllPages(),
	])

	const crumbs = await getBreadCrumbs(page, allPages)

	return {
		props: {
			page,
			allPages,
			crumbs,
			layoutData: { ...layoutData },
		},
	}
}

export async function getStaticPaths() {
	const pages = await getAllDocumentsByType('newsarticle')
	const paths = pages.map((page) => ({ params: { uid: page.uid } }))

	return {
		paths,
		fallback: false,
	}
}

export default Index
